import React from "react"
import { NavLink, useNavigate } from "react-router-dom"
import './header.css'
import { Navbar, Nav } from 'react-bootstrap';



function Header() {



    const navigate = useNavigate();



    function logout() {
        sessionStorage.removeItem('token');

        navigate('/')
    }

    const token = sessionStorage.getItem('token')

    if (token !== "" && token !== null) {
        return (

            <>

                <Navbar collapseOnSelect expand="lg">
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse className="justify-content-center" id="responsive-navbar-nav">
                        <Nav >

                            <ul className="nav nav-underline ul ">
                                

                                 <button onClick={logout} className="  btn  btn-light " to="/">Cerrar Sesión</button>


                           


                            </ul>

                        </Nav>

                    </Navbar.Collapse>
                </Navbar>


            </>
        )
    }
    else {
        return (

            <div className="container-fluid header">

               

                            <ul className="nav nav-underline ul ">
                                <li className="nav-item"><NavLink className="nav-link " to="/login">Iniciar Sesión</NavLink></li>








                            </ul>



            </div>
        );
    }


}

export default Header






